import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import styles from './Modal.module.scss';

interface Props {
  className?: string;
}

const ModalActions: React.FC<PropsWithChildren<Props>> = ({ className, children }) => {
  return <div className={clsx(styles.actions, className)}>{children}</div>;
};

export default ModalActions;
